import { validateToken as validateTokenApi } from "../../hooks/api/user/callbacks";
import { clearCookie, getToken, setCookie } from "../../lib/utils";
import { IUserInfo } from "../../types/api/user";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface UserStore {
  isLoggedIn: boolean;
   isHydrated: boolean;
  token: string | null;
  user: IUserInfo | null;

  updateToken: (data: {
    token: string | null;
    user: IUserInfo | null;
    remember?: boolean;
  }) => void;

  updateUser: (user: IUserInfo) => void;

  logout: () => void;

  validateToken: () => Promise<boolean>;
}



export const useUserStore = create<UserStore>()(
  devtools((set, get) => {
const setAuthState = (data: {
  token: string;
  user: IUserInfo | null;
  remember?: boolean;
}) => {
  set({
    token: data.token,
    user: data.user,
    isLoggedIn: true,
  });

  // Remember me checked -> persists 30 days across browser restarts.
  // Unchecked -> session cookie, cleared when the browser fully closes.
  setCookie("token", data.token, data.remember ? 30 : undefined);
};

    const resetAuth = () => {
      set({
        isLoggedIn: false,
        token: null,
        user: null,
      });

      clearCookie("token");
    };
    return {
      isLoggedIn: false,
      isHydrated: false,
      token: null,
      user: null,

      updateToken: setAuthState,

      updateUser: (user) => {
        set({ user });
      },

      logout: resetAuth,

 validateToken: async () => {
  try {
    
     const token = getToken();

    if (!token) {
      resetAuth();
      set({ isHydrated: true });
      return false;
    }

    const res = await validateTokenApi();

    // 2. FIX: backend doesn't return "success"
    if (!res?.data?.data) {
      resetAuth();
      set({ isHydrated: true });
      return false;
    }


    set({
      token,
      user: res.data.data,
      isLoggedIn: true,
      isHydrated: true,
    });

    return true;
  } catch {
    resetAuth();
    set({ isHydrated: true });
    return false;
  }
},
    };
  })
);